import React, { useEffect, useState } from 'react';
import { useApp } from '../appContext';

export default function SplashScreen() {
  const { showSplash, dismissSplash } = useApp();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!showSplash) return;
    setProgress(0);
    const start = Date.now();
    const duration = 9000;
    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      setProgress(Math.min((elapsed / duration) * 100, 100));
      if (elapsed >= duration) {
        clearInterval(interval);
        dismissSplash();
      }
    }, 100);
    return () => clearInterval(interval);
  }, [showSplash, dismissSplash]);

  if (!showSplash) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center cursor-pointer"
      style={{ background: 'linear-gradient(135deg, #4C9E00 0%, #2D6200 100%)' }}
      onClick={dismissSplash}
    >
      {/* Nutrien branding */}
      <div className="flex flex-col items-center gap-8 px-8 text-center">
        {/* Logo */}
        <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-2xl">
          <svg
            className="w-14 h-14"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 3C16 3 6 9 6 18C6 23.52 10.48 28 16 28C21.52 28 26 23.52 26 18C26 9 16 3 16 3Z"
              fill="#4C9E00"
              opacity="0.3"
            />
            <path
              d="M16 3C16 3 6 9 6 18C6 23.52 10.48 28 16 28C21.52 28 26 23.52 26 18C26 9 16 3 16 3Z"
              stroke="#4C9E00"
              strokeWidth="1.5"
              fill="none"
            />
            <path
              d="M16 28V14M16 14C16 14 11 17 9 22M16 14C16 14 21 17 23 22"
              stroke="#4C9E00"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>

        {/* Title */}
        <div>
          <h1 className="text-4xl font-bold text-white tracking-tight">
            Cory Ground Control
          </h1>
          <p className="text-white/70 mt-2 text-base font-medium">
            Nutrien — Cory Mine, Saskatchewan
          </p>
        </div>

        {/* Loading bar */}
        <div className="w-64 h-1.5 bg-white/20 rounded-full overflow-hidden">
          <div
            className="h-full bg-white rounded-full transition-all duration-100"
            style={{ width: `${progress}%` }}
          />
        </div>

        <p className="text-white/50 text-sm">Click anywhere to continue</p>
      </div>
    </div>
  );
}
